import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { ArrowBackRounded, InfoRounded } from "@mui/icons-material/";
import ReportPreviewTable from "../tables/ReportPreviewTable";
import { setSnackbar } from "../../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../../util/state/globalVariables";
import { GlobalContext } from "../../../../../util/state/GlobalContextProvider";
import { useRechargeRepository } from "../../../api/repositories/RechargeRepository";
import FinanceDialog from "../../../component/FinanceDialog";

const ReportPreview = () => {
    const { t } = useTranslation('finance', { keyPrefix: 'enelx' });
    const { dispatchGlobalData } = useContext(GlobalContext);

    const { getRechargesByReport, validateRecharges } = useRechargeRepository();

    let { id } = useParams();

    const [data, setData] = useState<any>([]);
    const [totalElements, setTotalElements] = useState<any>(0);
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    const navigate = useNavigate();

    const [updating, setUpdating] = useState(false);

    const [invoiceable, setInvoiceable] = useState<any>({});
    const [invoiceableLength, setInvoiceableLength] = useState(0);

    const onRowSelected = (id: string, isSelected: boolean, node: any) => {
        if (!isSelected) {
            delete invoiceable[id];
        } else {
            invoiceable[id] = node;
        }
    }

    useEffect(() => {
        getRechargesByReport(id!, 0, 100000, null, null)
            .then(response => {
                let result = response.result;
                setData(result.content);
                setTotalElements(result.page.totalElements);
            });
    }, []);

    useEffect(() => {
        if (updating) {
            getRechargesByReport(id!, 0, 100000, null, null)
                .then(response => {
                    let result = response.result;
                    setData(result.content);
                    setTotalElements(result.page.totalElements);
                    setUpdating(false);
                });
        }
    }, [updating])

    const sendInvoices = () => {
        validateRecharges(Object.keys(invoiceable))
            .then(() => {
                setUpdating(true);
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t('preview.send-bill-confirmation.success-snackbar'),
                            type: snackbarTypes.success,
                            show: true,
                            autoClose: true
                        }
                    }
                });
            })
            .finally(() => {
                setInvoiceable({});
                setInvoiceableLength(0);
            })
    }

    function handleCloseConfirmationModal() {
        setOpenConfirmationModal(false);
    }

    return (
        <Card variant="outlined" sx={{ margin: '15px' }}>
            <CardContent>
                <Grid container direction={'column'} rowGap={2}>
                    <Grid item>
                        <Box style={{ display: 'flex', alignItems: 'center', gap: '1ch' }}>
                           {/*<ArrowBackRounded style={{ verticalAlign: "middle", cursor: "pointer" }}*/}
                           {/*                   onClick={() => navigate('/finance/enel-x')}/>*/}
                            <Typography variant={'body1'} fontWeight={'bold'}>
                                {t('preview.buttons.back', { reportName: data['0']?.reportName })}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item>
                        <ReportPreviewTable data={data} selectedDataLength={invoiceableLength}
                                            setSelectedDataLength={setInvoiceableLength}
                                            onRowSelected={onRowSelected} onInvoiceClick={() => setOpenConfirmationModal(true)}
                        />
                    </Grid>
                </Grid>
            </CardContent>
            <FinanceDialog title={t('preview.send-bill-confirmation.title')}
                           content={t('preview.send-bill-confirmation.text', { selectedRecharges: invoiceableLength, totalRecharges: totalElements })}
                           open={openConfirmationModal}
                           onClose={handleCloseConfirmationModal}
                           callback={sendInvoices}
                           cancelButton={t('preview.send-bill-confirmation.cancel')}
                           confirmButton={t('preview.send-bill-confirmation.confirm')}
                           titleIcon={<InfoRounded style={{ color: 'accent.main' }}/>}
            />
        </Card>
    );
}

export default ReportPreview;